import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ADS_ANALYTICS_FALLBACK_ROUTE, ADS_ANALYTICS_ROUTE } from './access';
import useAdsAnalyticsAccess from './hooks/useAdsAnalyticsAccess';
import { AnalyticsPage } from './Loadable';

export default () => {
  const { canAccess, isLoading } = useAdsAnalyticsAccess();
  const getRouteContent = () => {
    if (isLoading) {
      return null;
    }

    if (canAccess) {
      return <AnalyticsPage />;
    }

    return <Redirect to={ADS_ANALYTICS_FALLBACK_ROUTE} />;
  };

  return (
    <Switch>
      <Route path={ADS_ANALYTICS_ROUTE}>{getRouteContent()}</Route>
    </Switch>
  );
};
